import { isAxiosError } from "axios";
import { extractApiErrorMessage, getApiErrorStatus } from "./apiError";

const MIGRATION_DELETE_FAILED_MESSAGE = "Failed to delete migration";

interface GetMigrationDeleteToastMessageOptions {
    statusesWithServerMessage: readonly number[];
}

export function getMigrationDeleteToastMessage<T>(
    error: T,
    { statusesWithServerMessage }: GetMigrationDeleteToastMessageOptions,
): string {
    const status = getApiErrorStatus(error);
    if (
        !isAxiosError(error) ||
        status === undefined ||
        !statusesWithServerMessage.includes(status)
    ) {
        return MIGRATION_DELETE_FAILED_MESSAGE;
    }

    return extractApiErrorMessage(
        error.response?.data,
        MIGRATION_DELETE_FAILED_MESSAGE,
    );
}
